import Model from 'src/app/core/models/model';
import UOMMasterModel from './uom.model';
import ItemMasterModel from './item-master.model';

export default class UOMConversionModel extends Model {
  FromUOM?: UOMMasterModel;
  ToUOM?: UOMMasterModel;
  ItemMaster?: ItemMasterModel;
  from_value: number;
  from_units_uom_id?: number;
  to_value?: number;
  to_units_uom_id?: number;
  item_id?: number;
  system_defined: boolean;

  constructor() {
    super();
  }
}
